module.exports = __webpack_public_path__ + "img/OPENED.fd17666e.png";